/**
 * 2025 Tax Year Rules
 * Combines federal and state rules
 */

import { cashMedicalSupportLevelsIA2025 } from './IA/cashMedicalSupportLevels';
import { childSupportLevelsIA2025 } from './IA/childSupportLevels';
import { TaxRules } from '../../types';

export const taxRules2025: TaxRules = {
    year: 2025,
    federal: {
        filing: {
            single: {
                standardDeduction: 15_000,
                over65Deduction: 2_000,
                blindDeduction: 2_000,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 11925.99, rate: 0.10 },
                    { minimumIncome: 11926, maximumIncome: 48475.99, rate: 0.12 },
                    { minimumIncome: 48476, maximumIncome: 103350.99, rate: 0.22 },
                    { minimumIncome: 103351, maximumIncome: 197300.99, rate: 0.24 },
                    { minimumIncome: 197301, maximumIncome: 250525.99, rate: 0.32 },
                    { minimumIncome: 250526, maximumIncome: 626350.99, rate: 0.35 },
                    { minimumIncome: 626351, rate: 0.37 },
                ],
            },
            marriedFilingSeparately: {
                standardDeduction: 15_000,
                over65Deduction: 1_600,
                blindDeduction: 1_600,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 11925.99, rate: 0.10 },
                    { minimumIncome: 11926, maximumIncome: 48475.99, rate: 0.12 },
                    { minimumIncome: 48476, maximumIncome: 103350.99, rate: 0.22 },
                    { minimumIncome: 103351, maximumIncome: 197300.99, rate: 0.24 },
                    { minimumIncome: 197301, maximumIncome: 250525.99, rate: 0.32 },
                    { minimumIncome: 250526, maximumIncome: 375800.99, rate: 0.35 },
                    { minimumIncome: 375801, rate: 0.37 },
                ],
            },
            headOfHousehold: {
                standardDeduction: 22_500,
                over65Deduction: 1_600,
                blindDeduction: 1_600,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 17000.99, rate: 0.10 },
                    { minimumIncome: 17001, maximumIncome: 64850.99, rate: 0.12 },
                    { minimumIncome: 64851, maximumIncome: 103350.99, rate: 0.22 },
                    { minimumIncome: 103351, maximumIncome: 197300.99, rate: 0.24 },
                    { minimumIncome: 197301, maximumIncome: 250500.99, rate: 0.32 },
                    { minimumIncome: 250501, maximumIncome: 626350.99, rate: 0.35 },
                    { minimumIncome: 626351, rate: 0.37 },
                ],
            }
        },
        fica: {
            regularSocialSecurityRate: 6.2,
            seSocialSecurityRate: 12.4,
            regularMedicareRate: 1.45,
            seMedicareRate: 2.9,
            additionalMedicareTaxRate: 0.90,
            socialSecurityThreshold: 176_100,
            additionalMedicareTaxThreshold: 200_000,
        },
        credits: {
            federalCreditPerDependentUnder17: 2_000,
            federalRefundableAmountPerChildUnder17: 1_700,
            federalCreditPerDependent17Over: 500,
            childTaxCreditPhaseOutThreshold: 200_000,
            phaseOutAmountPerChild: 50,
            dollarAbovePhaseoutThresholdIncrement: 1_000,
        },
        qbi: {
            tentativeRate: 0.20,
            thresholdStart: 197_300,
            thresholdEnd: 247_300,
            thresholdRate: 0.025
        },
        earnedIncome: {
            threshold: 2_500,
            agiMultiplier: 15, // as percentage
        },
        dependentCare: {
            limitOneDependent: 3_000,
            limitTwoOrMoreDependents: 6_000,
        },
    },
    states: {
        IA: {
            // Iowa state tax - flat rate for 2025
            standardDeductionSingle: 0,
            standardDeductionMarriedFilingSeparately: 0,
            standardDeductionHeadOfHousehold: 0,
            over65Deduction: 20,
            blindDeduction: 20,
            brackets: [
                { minimumIncome: 0, rate: 0.038 }, // 3.8% flat rate
            ],
            personalCredit: {
                single: 40,
                marriedFilingSeparately: 40,
                headOfHousehold: 80,
                perDependent: 40,
            },
            qadd: [
                { count: 0, rate: 0.00, minimum: 0 },
                { count: 1, rate: 0.08, minimum: 9_600 },
                { count: 2, rate: 0.12, minimum: 14_400 },
                { count: 3, rate: 0.14, minimum: 16_800 },
                { count: 4, rate: 0.15, minimum: 18_000 },
                { count: 5, rate: 0.16, minimum: 19_200 },
            ],
            support: {
                childSupport: childSupportLevelsIA2025,
                cashMedicalSupport: cashMedicalSupportLevelsIA2025,
            },
        },
    },
};
